module.exports = __webpack_public_path__ + "img/alert-line.d3347781.svg";